import { useEffect, useState } from "react";
import api from "../lib/api";
import { Card, Section, TH, TD, Empty, Input } from "../components/ui";

export default function AuditPage() {
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");
  const load = async (action) => {
    const { data } = await api.get(`/audit${action ? `?action=${encodeURIComponent(action)}` : ""}`);
    setItems(data);
  };
  useEffect(() => { load(); }, []);
  return (
    <div className="space-y-6" data-testid="audit-page">
      <Section title="Audit Log" subtitle="Tutte le azioni admin e di sistema">
        <Input placeholder="Filtra per azione (es: company, sync, auth)..." value={q}
               onChange={(e) => { setQ(e.target.value); load(e.target.value); }} data-testid="input-audit-filter" />
        <Card className="overflow-hidden">
          <table className="w-full">
            <thead className="bg-surface-hover/50 border-b border-border-default">
              <tr><TH>Quando</TH><TH>Attore</TH><TH>Azione</TH><TH>Target</TH><TH>IP</TH></tr>
            </thead>
            <tbody>
              {items.map((a) => (
                <tr key={a.id} className="border-b border-border-divider">
                  <TD className="font-mono text-xs">{new Date(a.created_at).toLocaleString("it-IT")}</TD>
                  <TD>{a.actor || "—"}</TD>
                  <TD className="font-mono text-xs">{a.action}</TD>
                  <TD className="font-mono text-xs">{a.target_type ? `${a.target_type}:${(a.target_id || "").slice(0, 8)}` : "—"}</TD>
                  <TD className="font-mono text-xs">{a.ip_address || "—"}</TD>
                </tr>
              ))}
              {items.length === 0 && <tr><td colSpan={5}><Empty>Nessuna voce.</Empty></td></tr>}
            </tbody>
          </table>
        </Card>
      </Section>
    </div>
  );
}
